import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Field, Select } from '@/components/ui/input';

/**
 * Campo de moneda con el catálogo de `/api/currencies`.
 *
 * Dos detalles que importan:
 * - si la moneda asignada **no está en la lista** (catálogo sin cargar, error de permisos o moneda
 *   desactivada), se añade una opción con su código: un desplegable controlado sin su propio valor
 *   enseñaría euro mientras guarda yuan.
 * - si no hay catálogo (aún cargando o error) siempre queda el euro, que es la moneda de la empresa.
 */
export function CurrencyField({ value, onChange, hint }: {
  value: string;
  onChange: (code: string) => void;
  hint?: string;
}) {
  const catalogo = useQuery({
    queryKey: ['currencies'],
    queryFn: () => api<{ data: { code: string; name: string; active?: boolean }[] }>('/currencies'),
    staleTime: 10 * 60 * 1000
  });

  const todos = catalogo.data?.data ?? [];
  // Solo las activas, más la que ya tenga asignada (aunque esté desactivada).
  const monedas = todos.filter((moneda) => moneda.active !== false || moneda.code === value);
  const falta = value !== '' && !monedas.some((moneda) => moneda.code === value);

  return (
    <Field label="Moneda" hint={hint ?? 'En la que factura: los pedidos la proponen'}>
      <Select value={value} onChange={(event) => onChange(event.target.value)}>
        {monedas.length === 0 ? <option value={value || 'EUR'}>{value || 'EUR'}</option> : null}
        {falta ? <option value={value}>{value} (fuera del catálogo)</option> : null}
        {monedas.map((moneda) => (
          <option key={moneda.code} value={moneda.code}>{moneda.code} · {moneda.name}</option>
        ))}
      </Select>
    </Field>
  );
}
